import { render, staticRenderFns } from "./UserPaymentMethods.vue?vue&type=template&id=325eb9f9&scoped=true"
import script from "./UserPaymentMethods.vue?vue&type=script&lang=js"
export * from "./UserPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./UserPaymentMethods.vue?vue&type=style&index=0&id=325eb9f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325eb9f9",
  null
  
)

export default component.exports